import React from 'react';
import { JobInterviewPicturePublicImageResponse } from '@doda/api-client/aspida/@types';
import { Text } from '@doda/io-react/common';
import styles from './index.module.scss';

const NO_IMAGE_PATH = '/assets/image/img_R60_D_190_01_job03.gif';

/**
 * PicturePublicImagesのProps
 */
interface PicturePublicImagesProps {
  picturePublicImages: JobInterviewPicturePublicImageResponse[];
}

/** 3点画像 */
export const ThreeImages: React.FC<PicturePublicImagesProps> = ({
  picturePublicImages,
}) => {
  return (
    <div className={styles['jobSearchDetail-threeImages']}>
      {picturePublicImages.map(({ index, path, caption }) => (
        <div
          key={index}
          className={styles['jobSearchDetail-threeImages__imageContainer']}
        >
          <img
            src={path || NO_IMAGE_PATH}
            className={styles['jobSearchDetail-threeImages__image']}
            alt=""
            onError={(event) => {
              window.DD_LOGS?.logger.info(
                `jobDetail image not found image:${path}`
              );
              event.currentTarget.srcset = '';
              event.currentTarget.src = NO_IMAGE_PATH;
            }}
          />
          <Text size="11" color="gray" style={{ marginTop: '8px' }}>
            {caption}
          </Text>
        </div>
      ))}
    </div>
  );
};
